var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "history-date-tracker history-content" }, [
    _c("div", [
      _vm.showLeftChevron
        ? _c("span", { on: { click: _vm.moveBackwards } }, [_vm._v("<")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "select",
        _vm._l(_vm.allYears, function (y) {
          return _c(
            "option",
            {
              domProps: { selected: y === _vm.currentYear },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.changeYear.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n                " + _vm._s(y) + "\n            ")]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.showRightChevron
        ? _c("span", { on: { click: _vm.moveForwards } }, [_vm._v(">")])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }